import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import Badge from 'components/Badge';
import { TilePlayButton } from 'components/TileLegacy/TilePartials';
import Favorite, {
  FAVORITE_TYPE_LINK,
  FAVORITE_PLUS_CIRCLE,
  FAVORITE_HEART,
} from 'components/Favorite';

import classNames from 'classnames';
import Dotdotdot from 'react-dotdotdot';

class ImageOverlay extends PureComponent {
  render() {
    const {
      badge,
      description,
      favoriteData,
      favoritesManager,
      isHoverStateV2,
      isPersonality,
      isSeriesDetailAvailable,
      metadata,
      network,
      networkLogoUrl,
      onTitleClick,
      playButtonText,
      renderImageOverlay,
      showPlayButton,
      subtitle,
      theme,
      title,
      titleLink,
      upcomingDate,
    } = this.props;
    // eslint-disable-next-line react/prop-types
    const renderFavorite = ({ withLabel }) => {
      if (_.get(favoriteData, 'favoritableItems')) {
        const { showType } = favoriteData;
        const favorites = _.get(favoritesManager, 'favorites');
        let defaultText = '';
        let favoritedText = '';

        if (withLabel) {
          if (!isPersonality) {
            defaultText = 'Watchlist';
            favoritedText = 'Watchlist';
          } else {
            defaultText = `Favorite ${showType}`;
            favoritedText = `Unfavorite ${showType}`;
          }
        }

        const iconType = !isPersonality ? FAVORITE_PLUS_CIRCLE : FAVORITE_HEART;

        return (
          <Favorite
            theme={theme}
            manager={favoritesManager}
            favorites={favorites}
            data={favoriteData}
            type={FAVORITE_TYPE_LINK}
            defaultText={defaultText}
            favoritedText={favoritedText}
            stopNavigationOnClick
            iconType={iconType}
          />
        );
      }
      return null;
    };

    const titleDisplay =
      titleLink && isSeriesDetailAvailable ? (
        <Link onClick={onTitleClick} to={titleLink}>
          {title}
        </Link>
      ) : (
        title
      );
    const imageOverlayHiddenClass = !renderImageOverlay && theme.imageOverlayHidden;
    const imageOverlayClasses = [theme.imageOverlay, imageOverlayHiddenClass];
    if (isHoverStateV2) {
      return (
        <div className={classNames(imageOverlayClasses)}>
          <div className={theme.imageOverlayInnerContainer}>
            <div className={theme.imageOverlayDetailContainer}>
              <Badge {...{ theme, badge }} title={title} />
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className={classNames(imageOverlayClasses)}>
        <div className={theme.imageOverlayInnerContainer}>
          <div className={theme.imageOverlayDetailContainer}>
            <Badge {...{ theme, badge }} title={title} />
            <div className={theme.imageOverlayDate}>{upcomingDate}</div>
            <div className={theme.imageOverlayTitle}>
              {titleDisplay}
              {!upcomingDate && (
                <span className={theme.titleFavorite}>{renderFavorite({ withLabel: false })}</span>
              )}
            </div>
            {subtitle && <div className={theme.imageOverlaySubtitle}>{subtitle}</div>}
            <div className={theme.imageOverlayDescription}>
              <Dotdotdot clamp={2}>{description}</Dotdotdot>
            </div>
          </div>
          <div className={theme.imageOverlayFooter}>
            <div>
              {!!networkLogoUrl && (
                <img alt={network} className={theme.imageOverlayNetworkLogo} src={networkLogoUrl} />
              )}
              {metadata && <span className={theme.imageOverlayMetadata}>{metadata}</span>}
            </div>
            <TilePlayButton theme={theme} playButton={showPlayButton} text={playButtonText} />
            <div>{upcomingDate && renderFavorite({ withLabel: true })}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default ImageOverlay;

ImageOverlay.defaultProps = {
  badge: null,
  breakpoint: null,
  description: null,
  favoriteData: null,
  favoritesManager: null,
  isHoverStateV2: false,
  isPersonality: false,
  isSeriesDetailAvailable: true,
  metadata: null,
  network: null,
  networkLogoUrl: null,
  onTitleClick: () => {},
  playButtonText: null,
  renderImageOverlay: false,
  showPlayButton: true,
  subtitle: null,
  theme: {},
  title: null,
  titleLink: null,
  upcomingDate: null,
};

ImageOverlay.propTypes = {
  badge: PropTypes.string,
  breakpoint: PropTypes.string,
  description: PropTypes.string,
  favoriteData: PropTypes.shape({}),
  favoritesManager: PropTypes.shape({}),
  isHoverStateV2: PropTypes.bool,
  isPersonality: PropTypes.bool,
  isSeriesDetailAvailable: PropTypes.bool,
  metadata: PropTypes.string,
  network: PropTypes.string,
  networkLogoUrl: PropTypes.string,
  onTitleClick: PropTypes.func,
  playButtonText: PropTypes.string,
  renderImageOverlay: PropTypes.bool,
  showPlayButton: PropTypes.bool,
  subtitle: PropTypes.string,
  theme: PropTypes.shape({}),
  title: PropTypes.string,
  titleLink: PropTypes.string,
  upcomingDate: PropTypes.string,
};
